import { render } from "./Backdrop.vue?vue&type=template&id=11893cc4&scoped=true&ts=true"
import script from "./Backdrop.vue?vue&type=script&lang=ts"
export * from "./Backdrop.vue?vue&type=script&lang=ts"

import "./Backdrop.vue?vue&type=style&index=0&id=11893cc4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11893cc4"]])

export default __exports__